import React, { useState } from 'react';
import i18n from '../../../../i18n';

import { useAction } from 'core/store/store';

import { makeCatalogSubmitProductAction } from 'state/catalog/actions';

import { AddProductForm } from 'forms/AddProductForm/AddProductForm';
import { DialogNew } from '../../../components/Dialog/DialogNew';

export interface CatalogAddDialogProps {
    onClose: () => void;
    // Optional
    isVendor?: boolean;
}

export const CatalogAddDialog = (props: CatalogAddDialogProps) => {
    const { onClose, isVendor } = props;
    const action = useAction();
    const { t } = i18n.useTranslation();

    const [coverImageCrop, setCoverImageCrop] = useState(null);

    return (
        <DialogNew disableContentPadding title={t('onboarding:card.addTitle')} onClose={onClose}>
            <AddProductForm
                onChangeCoverImageCrop={setCoverImageCrop}
                onSubmit={(data: any) => {
                    action(makeCatalogSubmitProductAction, { ...data, coverImageCrop }, isVendor);
                }}
                onClose={onClose}
            />
        </DialogNew>
    );
};
